var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoteInternal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9 7 15 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.437 17.838v-2.121l5.303-5.304 2.121 2.122-5.303 5.303zm8.485-6.347L20.801 9.37l.767-.767a1.057 1.057 0 0 1 1.5 0l.62.62a1.06 1.06 0 0 1 0 1.501zm-5.612 7.135 2.856-2.894v6.336a.926.926 0 0 1-.92.932H9.92a.926.926 0 0 1-.92-.932V7.932C9 7.417 9.412 7 9.92 7h9.326c.508 0 .92.417.92.932v.424l-.223.226-.262.264-.008-.008-.777.787-5.235 5.304-.321.326v3.697h3.648z"
})));
export default SvgNoteInternal;